import { useState, useEffect, useMemo, useRef } from "react";
import { Link } from "react-router-dom";

import { useBooking } from "../../store/bookingStore";
import { useBookingPricingSync } from "../../hooks/useBookingPricingSync";
import classes from "./Booking.module.css"
import BookingFirst from "./BookingFirst";
import Equipment from "./Equipment";
import Checkout from "./Checkout";
import BookingConfirmation from "./BookingConfirmation";
// import userImage from "../../public/images/userImage.png"
import AddPackage from "./AddPackage";
import { normalizePaidEquipmentInput } from "../../pages/StudioProfile/paidEquipmentHelpers";
import { trackBookingStepViewed } from "../../util/tracking";

// const DetailsPopup = ({ onClose, studio }) => {
//     const { bookingData } = useBooking();
    
//     const startTimeNum = parseInt(bookingData.startTime);
//     const endTimeNum = parseInt(bookingData.endTime);
//     const totalHours = endTimeNum - startTimeNum;

//   return (
//     <div className={classes.popupOverlay}>
//         <header className={classes.popupHeader}>
//             <span></span>
//             <h3 className="semiboldLarge">Preis Details</h3>
//             <button className={classes.closeButton} onClick={onClose}>
//                 <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
//                     <path fillRule="evenodd" clipRule="evenodd" d="M7.50502 9.24498L0 1.73995L0.989949 0.75L8.49498 8.25502L16 0.75L16.9899 1.73995L9.48492 9.24498L16.9899 16.75L16 17.7399L8.49498 10.2349L0.989949 17.7399L0 16.75L7.50502 9.24498Z" fill="#1F1F1F"/>
//                 </svg>
//             </button>
//         </header>
//         <div className={classes.horizontalLine}></div>
//         <div className={classes.popupContent}>
//             <h3 className="titleSemibold3">Price</h3>
//             <div className={`${classes.priceContainer} regularLarge`}>
//                 <span>{studio.pricePerHour} € x {totalHours} Stunden</span>
//                 <span>{studio.pricePerHour * totalHours} €</span>
//             </div>
//             {bookingData.addFreelancer && (
//                 <div className={`${classes.priceContainer} regularLarge`}>  
//                     <span>Fotograf/in: 40 € x {totalHours} Stunden </span>
//                     <span>{40 * totalHours} €</span>
//                 </div>
//             )}
//             {/* Equipment section commented out 
//             {bookingData.equipment.length > 0 && (
//                 bookingData.equipment.map((item) => (
//                     <div className={classes.priceContainer} key={item.name}>
//                         {
//                         item.count > 0 && (
//                             <>
//                             <span>{item.name}: {item.totalPrice / item.count} € x {item.count}</span>
//                             <span>{item.totalPrice} €</span>
//                             </>
//                         )
//                         }
//                         { 
//                         item.checked === true && (
//                             <>
//                             <span>{item.name}: {item.totalPrice} €</span>
//                             <span>{item.totalPrice} €</span>
//                             </>
//                         )
//                         }
//                     </div>
//                 ))
//             )}
//             */}
//             <div className={classes.horizontalLine }></div>
//         </div>
//         <div className={classes.popupGesamtbetrag}>
//             <h3 className="titleSemibold3">Gesamtbetrag</h3>
//             <span className="titleSemibold3">{bookingData.pricePerHour} €</span>
//         </div>
//     </div>
//   );
// };

export const Booking = ({ 
        studioCreativesData,
        processedProfilePicture,
        firstName,
        studioId,
        setShowBookingProcedure, 
        studio,
        bookingStudioData,
        minHours,
        studioPrice,
        date,
        setDate,
        startTime,
        setStartTime,
        endTime,
        setEndTime,
        numberOfPeople,
        setNumberOfPeople,
        onClose,
        showPackageModal,
        setShowPackageModal,
        packageModalFromOverlay,
        setPackageModalFromOverlay,
    }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false);
    const bookingCarouselRef = useRef(null);
    const bookingSlideRef = useRef(null);
    // const [showDetailsPopup, setShowDetailsPopup] = useState(false);
    const [showBookingConfirmation, setShowBookingConfirmation] = useState(false);
    const [dateTimeValidationError, setDateTimeValidationError] = useState(false);
    const lastTrackedBookingStepRef = useRef(null);
   
    const { bookingData, updateBookingData } = useBooking();

    // Check if package-based pricing
    // IMPORTANT:
    // - Only treat the studio as "package pricing" when pricingMode is explicitly "PACKAGES"
    // - Studios with pricingMode === "HOURLY" must stay hourly even if packages exist
    const isPackagePricing = useMemo(() => {
        return studio?.pricingMode === 'PACKAGES';
    }, [studio?.pricingMode]);

    useBookingPricingSync({
        bookingStudioData,
        bookingData,
        updateBookingData,
        studioCreativesData,
        isPackagePricing,
    });

    // Lock body scroll when modal is open
    useEffect(() => {
        // Get current scroll position before locking
        const scrollY = window.scrollY;
        
        // Apply styles to prevent scrolling
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = '100%';
        
        // iOS Safari specific fixes
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        if (isIOS) {
            document.body.style.height = '100vh';
            document.body.style.height = '100dvh'; // Use dynamic viewport height if supported
        }
        
        // Cleanup function to restore original styles
        return () => {
            // Always restore to empty strings to remove inline styles
            // This ensures CSS cascade takes over and page returns to normal scrollable state
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.body.style.height = '';
            
            // Restore scroll position
            window.scrollTo(0, scrollY);
        };
    }, []);

    const nextSlide = () => {
        // Check if total price is 0 and we're on the first slide
        if (currentSlide === 0 && bookingData.totalPrice === 0) {
            return;
        }
        
        // For package pricing mode, validate that date and time are selected on the first slide
        if (currentSlide === 0 && isPackagePricing) {
            if (!bookingData.date || !bookingData.startTime || !bookingData.endTime) {
                setDateTimeValidationError(true);
                return;
            }
        }
        
        // Clear validation error if validation passes
        setDateTimeValidationError(false);
        
        if (currentSlide < totalSlides - 1) {
            setIsTransitioning(true);
            setTimeout(() => {
                setCurrentSlide(currentSlide + 1);
                setIsTransitioning(false);
            }, 300);
        }
    };

    const prevSlide = () => {
        // Clear validation error when going back
        setDateTimeValidationError(false);
        
        if (currentSlide > 0) {
            setIsTransitioning(true);
            setTimeout(() => {
                setCurrentSlide(currentSlide - 1);
                setIsTransitioning(false);
            }, 300);
        } else if (currentSlide === 0) {
            // Clear date and total price ONLY if user is in package pricing mode
            if (isPackagePricing) {
                setDate(null);
                updateBookingData('date', '');
                updateBookingData('startTime', '');
                updateBookingData('endTime', '');
                updateBookingData('totalPrice', 0);
                updateBookingData('totalStudioPrice', 0);
                updateBookingData('serviceFee', 0);
                updateBookingData('appliedDiscount', 0);
                updateBookingData('appliedSurcharge', 0);
                updateBookingData('appliedFees', []);
            }
            onClose?.();
        }
    };

    const showConfirmation = () => {
        setShowBookingConfirmation(true);
    };
    
    const hasPaidEquipmentStep = useMemo(() => {
        const api = normalizePaidEquipmentInput(studio?.optionalBookableEquipment);
        return api.length > 0;
    }, [studio?.optionalBookableEquipment]);

    // Check if there are any creative packages available
    const hasCreativePackages = useMemo(() => {
        const packagesFromCreatives = studioCreativesData?.some(
            (sc) => sc?.creative?.packages?.items && Array.isArray(sc.creative.packages.items) && sc.creative.packages.items.length > 0
        );
        
        // Check both sources
        const hasStudioPackages = studio?.creativePackages && Array.isArray(studio.creativePackages) && studio.creativePackages.length > 0;
        const hasCreativesPackages = packagesFromCreatives;
        
        return hasStudioPackages || hasCreativesPackages;
    }, [studio?.creativePackages, studioCreativesData]);
    
    // Clear validation error when date/time changes
    useEffect(() => {
        if (bookingData.date && bookingData.startTime && bookingData.endTime) {
            setDateTimeValidationError(false);
        }
    }, [bookingData.date, bookingData.startTime, bookingData.endTime]);

    // Booking modal scroll lives on .carousel / .slide (overflow-y: auto), not window
    useEffect(() => {
        const carousel = bookingCarouselRef.current;
        const slide = bookingSlideRef.current;
        if (carousel) carousel.scrollTop = 0;
        if (slide) slide.scrollTop = 0;
    }, [currentSlide]);
    
    const slides = [
        <BookingFirst 
            minHours={minHours} 
            studioPrice={studioPrice}
            bookingStudioData={bookingStudioData} 
            style={true} 
            studio={studio} 
            studioCreativesData={studioCreativesData}
            setDate={setDate} 
            date={date}
            startTime={startTime}
            setStartTime={setStartTime} 
            endTime={endTime}
            setEndTime={setEndTime} 
            numberOfPeople={numberOfPeople}
            setNumberOfPeople={setNumberOfPeople} 
            onClose={onClose}
            setShowPackageModal={setShowPackageModal}
            setPackageModalFromOverlay={setPackageModalFromOverlay}
        />, 
        ...(hasCreativePackages ? [
            <AddPackage 
                availablePackages={studio.creativePackages}
                processedProfilePicture={processedProfilePicture}
                firstName={firstName}
                studioId={studioId}
                studioCreativesData={studioCreativesData}
            />
        ] : []),
        
        ...(hasPaidEquipmentStep
            ? [<Equipment key="equipment" paidEquipment={studio?.optionalBookableEquipment} />]
            : []),
        <Checkout studio={studio} onPrevSlide={prevSlide} showConfirmation={showConfirmation} studioCreativesData={studioCreativesData} />
    ];
    
    const totalSlides = slides.length;
    const progressPercentage = ((currentSlide + 1) / totalSlides) * 100;

    /** Slide order: 0 Buchungsdetails → [1 Pakete if hasCreativePackages] → [equipment if hasPaidEquipmentStep] → checkout */
    const equipmentSlideIndex = hasPaidEquipmentStep ? (hasCreativePackages ? 2 : 1) : -1;
    const checkoutSlideIndex = totalSlides - 1;
    const isEquipmentSlide = hasPaidEquipmentStep && currentSlide === equipmentSlideIndex;
    const isCheckoutSlide = currentSlide === checkoutSlideIndex;

    const getStepName = (slideIndex) => {
        const stepNames = ["booking_details"];
        if (hasCreativePackages) stepNames.push("creative_packages");
        if (hasPaidEquipmentStep) stepNames.push("paid_equipment");
        stepNames.push("payment");
        return stepNames[slideIndex] || "booking_step";
    };
    const currentStepName = getStepName(currentSlide);

    useEffect(() => {
        const trackingSignature = `${studioId || studio?.id || "unknown"}:${currentSlide}:${currentStepName}`;
        if (lastTrackedBookingStepRef.current === trackingSignature) return;

        lastTrackedBookingStepRef.current = trackingSignature;
        trackBookingStepViewed({
            studio,
            studioId,
            stepIndex: currentSlide + 1,
            stepName: currentStepName,
            source: "booking_desktop",
        });
    }, [currentSlide, currentStepName, studio, studioId]);

    const getStepColor = (slideIndex) => {
        return currentSlide === slideIndex ? "white" : "var(--grey-1)";
    };

    const stepChevron = (
        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none" aria-hidden>
            <line x1="0.576712" y1="10.6773" x2="5.90482" y2="5.34919" stroke="#A1A7AE" strokeWidth="1.2" />
            <line x1="5.88724" y1="6.18041" x2="0.559129" y2="0.408283" stroke="#A1A7AE" strokeWidth="1.2" />
        </svg>
    );

  return (
    <div className={classes.container}>
        {!showBookingConfirmation && (
        <>
        <header className={classes.header}>
            <div className={classes.headerContainer}>
            <div className={classes.logoContainer}>
                <Link to="/" className={classes.logoContainer}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="63" height="22" viewBox="0 0 63 22" fill="none">
                        <path d="M59.881 10.9998C61.5389 10.9998 62.8828 9.65582 62.8828 7.99799C62.8828 6.34015 61.5389 4.99621 59.881 4.99621C58.2232 4.99621 56.8792 6.34015 56.8792 7.99799C56.8792 9.65582 58.2232 10.9998 59.881 10.9998Z" fill="#DF315A"/>
                        <path d="M11.1762 11.3413L9.54985 11.2047C5.52557 10.879 4.17024 10.4587 4.17024 9.54462C4.17024 8.63052 5.88004 8.12619 9.40389 8.12619C13.1258 8.12619 14.6271 8.62001 14.9399 9.94389L14.992 10.154H19.0788L19.0371 9.85983C18.6305 6.37153 15.5237 4.67992 9.54985 4.67992C3.57598 4.67992 0.510854 6.34001 0.510854 9.59716C0.510854 12.5811 2.96087 14.0206 8.98687 14.5669L10.4464 14.7035C14.4395 15.0503 15.9199 15.5756 15.9199 16.6263C15.9199 17.7715 14.0954 18.3599 10.4882 18.3599C6.40132 18.3599 4.3162 17.5929 4.11811 16.0064L4.08683 15.7752H0V16.0589C0.187661 19.8729 3.60726 21.8062 10.1754 21.8062C16.7435 21.8062 19.5897 19.999 19.5897 16.4372C19.5897 13.2641 17.2335 11.8351 11.1762 11.3413Z" fill="white"/>
                        <path d="M49.8447 5.20516V12.0136C49.8447 15.8277 47.3529 18.1917 43.3495 18.1917C39.5859 18.1917 38.1159 16.5001 38.1159 12.1502V5.20516H25.48V0.193359L21.7164 1.79041V16.1429C21.7164 20.104 23.6138 21.7956 28.0656 21.7956C29.619 21.7956 31.1098 21.5329 32.3713 21.2703L32.5799 21.2282V17.8555L32.2671 17.9185C30.6303 18.2548 29.9005 18.3808 28.7328 18.3808C26.5747 18.3808 25.48 17.866 25.48 15.0396V8.35724H36.2184L34.2375 9.87024V13.3795C34.2375 19.1268 36.6563 21.7956 41.8378 21.7956C45.1844 21.7956 47.9368 20.6293 49.8447 18.4019V21.2703H53.723V5.20516H49.8447Z" fill="white"/>
                    </svg>
                </Link>
                <div className={classes.stepsContainer}>
                    <span className="regularMiddle" style={{ color: getStepColor(0) }}>Buchungsdetails</span>
                    {stepChevron}
                    {hasCreativePackages && (
                        <>
                            <span className="regularMiddle" style={{ color: getStepColor(1) }}>Kreative engagieren</span>
                            {stepChevron}
                        </>
                    )}
                    {hasPaidEquipmentStep && (
                        <>
                            <span className="regularMiddle" style={{ color: getStepColor(equipmentSlideIndex) }}>
                                Equipment
                            </span>
                            {stepChevron}
                        </>
                    )}
                    <span className="regularMiddle" style={{ color: getStepColor(checkoutSlideIndex) }}>Bezahlen</span>
                </div>
            </div>
            {/* <div className={classes.menuContainer}>
                <div className={classes.userImageContainer}>
                    <img src={userImage} alt="User Image" />
                </div>
                <span className="regularMiddle">Menü</span>
            </div> */}
            </div>
            <div className={classes.headerContainer2}>
                <Link to="/" className={classes.logoContainer}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="63" height="22" viewBox="0 0 63 22" fill="none">
                        <path d="M59.881 10.9998C61.5389 10.9998 62.8828 9.65582 62.8828 7.99799C62.8828 6.34015 61.5389 4.99621 59.881 4.99621C58.2232 4.99621 56.8792 6.34015 56.8792 7.99799C56.8792 9.65582 58.2232 10.9998 59.881 10.9998Z" fill="#DF315A"/>
                        <path d="M11.1762 11.3413L9.54985 11.2047C5.52557 10.879 4.17024 10.4587 4.17024 9.54462C4.17024 8.63052 5.88004 8.12619 9.40389 8.12619C13.1258 8.12619 14.6271 8.62001 14.9399 9.94389L14.992 10.154H19.0788L19.0371 9.85983C18.6305 6.37153 15.5237 4.67992 9.54985 4.67992C3.57598 4.67992 0.510854 6.34001 0.510854 9.59716C0.510854 12.5811 2.96087 14.0206 8.98687 14.5669L10.4464 14.7035C14.4395 15.0503 15.9199 15.5756 15.9199 16.6263C15.9199 17.7715 14.0954 18.3599 10.4882 18.3599C6.40132 18.3599 4.3162 17.5929 4.11811 16.0064L4.08683 15.7752H0V16.0589C0.187661 19.8729 3.60726 21.8062 10.1754 21.8062C16.7435 21.8062 19.5897 19.999 19.5897 16.4372C19.5897 13.2641 17.2335 11.8351 11.1762 11.3413Z" fill="white"/>
                        <path d="M49.8447 5.20516V12.0136C49.8447 15.8277 47.3529 18.1917 43.3495 18.1917C39.5859 18.1917 38.1159 16.5001 38.1159 12.1502V5.20516H25.48V0.193359L21.7164 1.79041V16.1429C21.7164 20.104 23.6138 21.7956 28.0656 21.7956C29.619 21.7956 31.1098 21.5329 32.3713 21.2703L32.5799 21.2282V17.8555L32.2671 17.9185C30.6303 18.2548 29.9005 18.3808 28.7328 18.3808C26.5747 18.3808 25.48 17.866 25.48 15.0396V8.35724H36.2184L34.2375 9.87024V13.3795C34.2375 19.1268 36.6563 21.7956 41.8378 21.7956C45.1844 21.7956 47.9368 20.6293 49.8447 18.4019V21.2703H53.723V5.20516H49.8447Z" fill="white"/>
                    </svg>
                </Link>
                <div className={classes.headerButtonsContainer}>
                    <div className={classes.stepsContainer}>
                        <span className="regularMiddle" style={{ color: getStepColor(0) }}>Buchungsdetails</span>
                        {stepChevron}
                        {hasCreativePackages && (
                            <>
                                <span className="regularMiddle" style={{ color: getStepColor(1) }}>Kreative engagieren</span>
                                {stepChevron}
                            </>
                        )}
                        {hasPaidEquipmentStep && (
                            <>
                                <span className="regularMiddle" style={{ color: getStepColor(equipmentSlideIndex) }}>
                                    Equipment
                                </span>
                                {stepChevron}
                            </>
                        )}
                        <span className="regularMiddle" style={{ color: getStepColor(checkoutSlideIndex) }}>
                            Bezahlen
                        </span>
                    </div>
                    {/* <div className={classes.menuContainer}>
                        <div className={classes.userImageContainer}>
                            <img src={userImage} alt="User Image" />
                        </div>
                        <span className="regularMiddle">Menü</span>
                    </div> */}
                </div>
            </div>
        </header>
        <div
            ref={bookingCarouselRef}
            className={`${classes.carousel} ${
                isEquipmentSlide || isCheckoutSlide ? classes.carouselEquipment : ""
            }`}
            style={{
                backgroundColor: "#FFFFFF",
                flexDirection: "row",
                alignItems: isEquipmentSlide || isCheckoutSlide ? "flex-start" : "center",
                ...(currentSlide === 1 &&
                    hasCreativePackages &&
                    !isEquipmentSlide &&
                    !isCheckoutSlide && { padding: "0 48px" }),
                ...((isEquipmentSlide || isCheckoutSlide) && { marginBottom: 0 }),
            }}
        >
            <div
                ref={bookingSlideRef}
                className={`${classes.slide} ${isTransitioning ? classes.transitioning : ""} ${classes.slideNormal} ${
                    isEquipmentSlide || isCheckoutSlide ? classes.slideEquipmentScroll : ""
                }`}
                style={{
                    width: isEquipmentSlide || isCheckoutSlide ? "100%" : "",
                    ...((isEquipmentSlide || isCheckoutSlide) && { justifyContent: "flex-start" }),
                }}
            >
                {slides[currentSlide]}
            </div>
        </div>
        {currentSlide < slides.length - 1 && (
        <footer className={classes.footer}>
            <div className={classes.progressBar}>
                <div
                    className={classes.progressBarInner}
                    style={{ width: `${progressPercentage}%` }}
                ></div>
            </div>
            <div className={classes.footerContainer}>
                <div onClick={prevSlide} className={classes.footerButtonsContainer}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="19" viewBox="0 0 11 19" fill="none">
                        <line x1="9.60104" y1="0.726041" x2="0.602492" y2="9.72459" stroke="#1F1F1F" strokeWidth="1.7"/>
                        <line x1="0.626536" y1="8.54651" x2="9.62508" y2="18.2949" stroke="#1F1F1F" strokeWidth="1.7"/>
                    </svg>
                    <button className={`${classes.footerBackButton} mediumLarge`}>Zurück</button>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '8px' }}>
                    {dateTimeValidationError && currentSlide === 0 && (
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: '8px',
                            color: '#CB1541',
                            fontSize: '0.875rem'
                        }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
                                <path fillRule="evenodd" clipRule="evenodd" d="M4.4452 5.5L0 1.0548L1.0548 0L5.5 4.4452L9.9452 0L11 1.0548L6.5548 5.5L11 9.9452L9.9452 11L5.5 6.5548L1.0548 11L0 9.9452L4.4452 5.5Z" fill="#CB1541"/>
                            </svg>
                            <span className="slimRegularSmallText">Bitte wähle ein Datum und eine Uhrzeit aus.</span>
                        </div>
                    )}
                    <button
                        onClick={nextSlide}
                        className={`${classes.footerWeiterButton} mediumLarge`}
                    >
                        Weiter
                    </button>
                </div>
            </div>
        </footer>
        )}
        </>
        )}
        {showBookingConfirmation && 
            <BookingConfirmation 
                studio={studio} 
                setShowBookingProcedure={setShowBookingProcedure} 
                onClose={onClose} 
            />
        }
    </div>
  );
};

export default Booking;
